import { createRequestFactory } from "@devowl-wp/utils";
import { rmlOpts } from "./rmlOpts.js";
let FACTORY_MEMO;
function get() {
    if (FACTORY_MEMO) {
        return FACTORY_MEMO;
    }
    return FACTORY_MEMO = createRequestFactory({
        ...rmlOpts,
        restNamespace: "realmedialibrary/v1"
    });
}
const urlBuilder = (...args)=>get().urlBuilder(...args);
const request = (...args)=>get().request(...args);
export { urlBuilder, request };
